<template lang="pug">
  .component-client-action-buttons
    .dropdown-buttons
      ModalReveal(ref="editReveal")
        button.button.warning(slot="trigger", type="button") Edit
        .row
          .columns
            label Name
              input(type="text", v-model="item.code")
          .columns
            label Group
              select(v-model="item.type")
                option PRIVATE
                option BUSINESS
                option MAINTENANCE
        .row.columns.text-center
          ActionButton(:action="edit") Update

      button.button.warning(type="button", v-on:click="remove") Delete
</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from 'src/maggieHelper'
import ModalReveal from '../../foundation/ModalReveal'
import ActionButton from "../ActionButton.vue";
import {EventBus} from "../../../../eventBus";

export default {
  name: 'ClientTypeButtons',
  components: {ActionButton, ModalReveal},
  data() {
    return {
      entity: {...this.item}
    }
  },
  created() {
  },
  methods: {
    remove: function () {
      this.$confirm('Are you sure?', `Do you really want to <strong>Remove</strong> the <strong>CT${this.item.id} client type?</strong>`, () => {
        KeplerBackofficeSdk.clientTypes.select(this.entity).remove(() => {
          MaggieHelper.notification('delete-esit', 'Client type removed')
          window.location.reload()
        })
      })
    },
    edit() {
      this.entity.name = this.item.code
      return KeplerBackofficeSdk.clientTypes.select(this.item).edit(this.entity,()=>{
        this.$refs.editReveal.close()
        EventBus.$emit('reload-list')
      })
    }
  },
  props: ['item']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ClientTypeButtons.vue?6e5081b9